<template>
  <div id="app">
<!--    <router-view v-if="isRouterAlive"/>-->

    <template v-if="isRouterAlive">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
  </div>
</template>

<script>
export default {
  name: "App",
  provide(){
    return {
      reload: this.reload,
      uploadFile: this.uploadFile,
    };
  },
  data(){
    return {
      isRouterAlive: true,
    };
  },
  created(){
    this.$store.commit('setUserType',this.$store.getters.getUserType);
  },
  methods: {
    // 用于在下单的时候删除数据
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
@import '../static/css/reset.css';
@import '../static/css/Public.css';
@import '../static/css/iconfont.css';

/* 隐藏滚动条 */

/* ::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
  color: transparent;
  background-color: transparent;
} */

html,body{
  width: 100%;
  height: 100%;
}
#app{
  width: 100%;
  height: 100%;
}
/*.el-table th.gutter{*/
/*  display: table-cell!important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue